export enum SizeEnum {
  SMALL = 1,
  MEDIUM = 2,
  BIG = 3,
  GIANT = 4,
  NA = 5,
  MINI = 6
}
